var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuildingSavings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H40C44.4183 0 48 3.58172 48 8V40C48 44.4183 44.4183 48 40 48H8C3.58172 48 0 44.4183 0 40V8Z",
    fill: "url(#paint0_linear_2130_159)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1716 10.8288L9.17157 22.8288C8.42143 23.5789 8 24.5964 8 25.6572V38.0004C8 39.1049 8.89543 40.0004 10 40.0004H19C19.5523 40.0004 20 39.5527 20 39.0004V32.0004C20 29.7912 21.7909 28.0004 24 28.0004C26.2091 28.0004 28 29.7912 28 32.0004V39.0004C28 39.5527 28.4477 40.0004 29 40.0004H38C39.1046 40.0004 40 39.1049 40 38.0004V25.6572C40 24.5964 39.5786 23.5789 38.8284 22.8288L26.8284 10.8288C25.2663 9.2667 22.7337 9.2667 21.1716 10.8288Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2130_159",
    x1: 1.06167e-7,
    y1: 0.264664,
    x2: 49.2178,
    y2: 46.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96EE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009112"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingSavings);
export default __webpack_public_path__ + "static/media/BuildingSavings.0c025e87062aff1d01d6d97d64b23f95.svg";
export { ForwardRef as ReactComponent };